import React from 'react';
import { Link } from 'react-router-dom';

const PageHero = ({ eyebrow, title, lead, image, imageAlt = '' }) => (
  <section className="page-hero">
    <div className="page-hero__bg">
      <img src={image} alt={imageAlt} fetchpriority="high" decoding="async" />
    </div>
    <div className="page-hero__scrim" />

    <div className="page-hero__inner">
      {eyebrow && <p className="eyebrow hero__eyebrow">{eyebrow}</p>}
      <h1 className="page-hero__title">{title}</h1>
      {lead && <p className="page-hero__lead">{lead}</p>}

      <nav className="breadcrumb" aria-label="Breadcrumb">
        <Link to="/">Home</Link>
        <span className="breadcrumb__sep" aria-hidden="true">
          /
        </span>
        <Link to="/#services">Services</Link>
        <span className="breadcrumb__sep" aria-hidden="true">
          /
        </span>
        <span aria-current="page">{title}</span>
      </nav>
    </div>
  </section>
);

export default PageHero;
